import "../css/Error.css";
import badRequest from "../assets/badRequest.svg";

const ErrorScreen = ({ stateCode }) => {
  const isError = stateCode.code === 404 || stateCode.code === 400;
  return (
    <div className="app" style={{ display: isError ? "block" : "none" }}>
      <header className="error-header">
        <img src={badRequest} className="App-logo" alt="logo" />
      </header>
      <div className="error-body">
        <div className="error-information-title">
          <span style={styles.badRequest}>페이지를 찾을 수 없습니다 :(</span>
        </div>
        <div className="error-information-context">
          <p>
            <span style={styles.emphasizedFont}>존재하지 않는 주소</span>를
            입력하셨거나,
            <br />
            요청하신 페이지의
            <span style={styles.emphasizedFont}> 주소가 변경, 삭제</span>되어
            찾을 수 없습니다
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  badRequest: {
    color: "#FF4646",
    paddingLeft: 15,
    paddingRight: 10,
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
    fontSize: 13,
  },
  emphasizedFont: {
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
  },
};

export default ErrorScreen;
